import { inject } from '@angular/core';
import { HttpContextToken, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '@core/auth';
import { isInterceptorDisabled } from './is-interceptor-disabled';

export const DISABLE_REFRESH_TOKEN_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const refreshTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const assetsReq = request.url.includes('assets');
  const refreshToken = authService.getRefreshToken();

  if (isInterceptorDisabled(request.context, DISABLE_REFRESH_TOKEN_INTERCEPTOR)) {
    return next(request);
  }

  if (assetsReq) {
    return next(request);
  }

  if (!refreshToken) {
    authService.logout();

    return throwError(() => new Error('Refresh token is not exist'));
  }

  return next(request).pipe(
      catchError(error => {
        if (error.status === HttpStatusCode.Unauthorized) {
          return authService.refresh().pipe(
              catchError((error) => {
                authService.logout();
                return throwError(() => error);
              }),
              switchMap(() => next(request.clone())),
          );
        }

        return throwError(() => error);
      }),
  );
};
